import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// guest SMS session token (stored client-side, backed by server-side verification)
const GUEST_KEY = "fg_guest_token";
export const getGuestToken = () => localStorage.getItem(GUEST_KEY);
export const setGuestToken = (t) => localStorage.setItem(GUEST_KEY, t);
export const clearGuestToken = () => localStorage.removeItem(GUEST_KEY);

api.interceptors.request.use((config) => {
  const t = getGuestToken();
  if (t && config.headers?.guest !== false) {
    config.headers.Authorization = `Bearer ${t}`;
  }
  delete config.headers.guest;
  return config;
});

export const friendlyError = (e, fallback = "Something went wrong. Please try again.") =>
  e?.response?.data?.detail || fallback;
